import React from "react";

const SpecializationsCard = ({ specializations }) => {
  return (
    <div className="bg-white rounded-2xl shadow-md p-8 border border-gray-200 mt-8">
      <h3 className="font-semibold text-gray-900 text-lg mb-4">
        Teaching Specializations
      </h3>

      <div className="flex gap-3 flex-wrap">
        {specializations.map((spec, i) => (
          <span
            key={i}
            className="px-4 py-2 bg-[#E6EDFF] text-[#3C4FDD] rounded-full text-sm font-medium"
          >
            {spec}
          </span>
        ))}
      </div>
    </div>
  );
};

export default SpecializationsCard;